export const esES = {
    common: {
        save: "Guardar",
        cancel: "Cancelar",
        add: "Añadir",
        edit: "Editar",
        done: "Listo",
        retry: "Reintentar",
        copy: "Copiar",
        copied: "Copiado",
        dismiss: "Descartar",
        hide: "Ocultar",
        show: "Mostrar",
        connect: "Conectar",
        disconnect: "Desconectar",
        name: "Nombre",
        email: "Correo electrónico",
        role: "Rol",
        status: "Estado",
        type: "Tipo",
        user: "Usuario",
        optional: "opcional",
    },
    nav: {
        users: "Usuarios",
        settings: "Configuración",
        aiProviders: "Proveedores de IA",
        auditLog: "Auditoría",
        tasks: "Tareas",
    },
    saveDock: {
        saving: "Guardando…",
        fixToSave: "Corrige para guardar",
        saveChanges: "Guardar cambios",
        saved: "Guardado",
        noChanges: "Sin cambios",
        unsavedHint: "Cambios sin guardar — se guarda automáticamente en 15s",
        ariaSave: "Guardar configuración de proveedores de IA",
    },
    config: {
        loading: "Cargando configuración del runtime...",
        sectionCredentials: "Credenciales de LLM",
        sectionLegacy: "Campos de proveedor heredados",
        sectionOauth: "Conexiones OAuth",
        sectionOpenrouter: "OpenRouter / Proveedor personalizado",
        sectionModelDefaults: "Valores predeterminados de modelo",
        sectionAliases: "Alias de modelo",
        sectionAgent: "Comportamiento del agente",
        legacyFields: {
            anthropicOauthToken: "Token OAuth Anthropic",
            anthropicApiKey: "Clave de API Anthropic",
            openaiApiKey: "Clave de API OpenAI",
            googleApiKey: "Clave de API Google",
            xaiApiKey: "Clave de API xAI",
        },
        legacyPresenceHelp: "Solo lectura — la tabla de arriba es el editor de credenciales. Estos valores permanecen cifrados en reposo como reserva latente y quedan sombreados por una entrada de la tabla para el mismo proveedor (las entradas migradas llevan una etiqueta “migrated: …”).",
        legacyNone: "No hay campos de proveedor heredados almacenados — la tabla de arriba es el único repositorio de credenciales.",
        oauthLoading: "Cargando estado de OAuth…",
        oauthHelp: "El OAuth de suscripción usa un flujo de código manual — Lexiun nunca ve tu contraseña de ChatGPT. Los tokens se almacenan cifrados y se renuevan de forma centralizada antes de expirar. Desconectar los borra de inmediato.",
        openrouterLoading: "Cargando estado del proveedor…",
        configured: "Configurado",
        notConfigured: "No configurado.",
        openrouterHelp: "Solo lectura — añade o edita endpoints de OpenRouter / personalizados como filas en la tabla de Credenciales de LLM de arriba (§8.10). Un blob heredado existente sigue funcionando como reserva latente; Desconectar lo borra.",
        openrouterDisconnectConfirm: "¿Desconectar OpenRouter? Los chats que dependen de esta credencial empezarán a fallar.",
        openrouterDisconnected: "OpenRouter desconectado.",
        chatProfile: "Perfil de chat",
        resolving: "Resolviendo…",
        resolvesTo: "Se resuelve a",
        resolvesThinking: "· thinking=",
        resolvesMaxOut: "· max-out=",
        profileHelpA: "Se resuelve a través del catálogo",
        profileHelpB: "de la plataforma. El compuesto",
        profileHelpC: "superpone el nivel de razonamiento sobre la política del perfil.",
        budgetPerTask: "Presupuesto por tarea",
        aliasesHelpBeforePrimary: "Asigna niveles de capacidad + alias de tarea personalizados a un proveedor/modelo, con una reserva opcional. Los harnesses + el valor de chat predeterminado se resuelven a través de esta tabla; una interrupción del proveedor desciende de",
        aliasesHelpPrimary: "Principal",
        aliasesHelpTo: "a",
        aliasesHelpFallback: "Reserva",
        aliasesHelpAfter: "automáticamente. La insignia de cada alias muestra a qué se resuelve ahora mismo.",
        thinkingLevel: "Nivel de razonamiento",
        notSet: "Sin definir",
        thinkingLow: "Bajo",
        thinkingMedium: "Medio",
        thinkingHigh: "Alto",
        maxAgentTurns: "Máx. de turnos del agente",
        systemPromptPrefix: "Prefijo del prompt de sistema",
        systemPromptPlaceholder: "Instrucciones específicas de la organización antepuestas a cada ejecución del agente...",
        systemPromptHelp: "El prefijo del prompt de sistema aún no lo aplica el runtime (compatible a futuro).",
        lastUpdated: "Última actualización: {date}",
        lastUpdatedBy: " por {user}",
        noChangesToSave: "No hay cambios que guardar",
        autoSaved: "Guardado automáticamente. Los cambios se sincronizan con el runtime en 60 segundos.",
        configSaved: "Configuración guardada. Los cambios se sincronizan con el runtime en 60 segundos.",
        validationFailed: "Falló la validación con LLM real: {label}{detail}{latency}. El modelo predeterminado NO se guardó.",
        previewRequestFailed: "Falló la solicitud de vista previa",
        blockingCredential: "Credencial {detail}. Complétala o elimina la fila.",
        blockingAlias: "Alias de modelo {detail}. Complétalo o elimina la fila.",
        validationCodes: {
            auth: "Falló la autenticación (la credencial es incorrecta o expiró)",
            "model-unknown": "Modelo desconocido para el proveedor",
            quota: "Cuota / límite de tasa superado",
            network: "Error de red al alcanzar el proveedor",
            schema: "El servidor rechazó el formato de la solicitud",
            unknown: "Falló la validación (motivo desconocido)",
        },
    },
    oauth: {
        openaiCodexDisplayName: "Suscripción OpenAI / ChatGPT",
        connected: "Conectado",
        connectedMsg: "Conectado.",
        disconnectedMsg: "Desconectado.",
        connectionBroken: "Conexión interrumpida",
        degraded: "Degradado",
        reconnect: "Reconectar",
        awaitingCode: "Esperando el código de autorización…",
        emptyValidation: "Pega la URL de redirección (o el código) del proveedor.",
        disconnectConfirm: "¿Desconectar {name}? Los chats existentes que dependen de esta credencial empezarán a fallar.",
        step1: "1. Abre la página de inicio de sesión de abajo (pestaña nueva), inicia sesión en {name} y autoriza.",
        step2: '2. Tras autorizar, el navegador abre una página localhost que muestra "Authentication successful" o no carga ("no se puede acceder a este sitio") — cualquiera de las dos está bien. Copia la URL completa de la barra de direcciones (contiene el code=…).',
        step3: "3. Pega esa URL aquí y haz clic en Completar:",
        urlPlaceholder: "pega la URL completa de redirección localhost",
        connecting: "Conectando…",
        complete: "Completar",
    },
    searchProviders: {
        title: "Proveedores de búsqueda",
        help: "Claves usadas en la búsqueda web del concierge. Una clave definida aquí pertenece a esta organización; sin ella, se usa el valor por defecto de la plataforma cuando esté disponible.",
        srcOrg: "clave de la organización",
        srcPlatform: "valor por defecto de la plataforma",
        srcNone: "sin configurar",
        disabledNote: "la búsqueda está desactivada para esta organización — la clave siguiente se conserva",
    },
    credentials: {
        colId: "ID",
        colProvider: "Proveedor",
        colKeySecret: "Clave / Secreto",
        colEndpoint: "Endpoint",
        addCredential: "Añadir credencial",
        emptyRow: "Aún no hay credenciales — añade una fila o usa los valores heredados de solo lectura que siguen almacenados abajo.",
        help: "Esta tabla es el editor de credenciales — una fila por clave/endpoint; las filas tienen prioridad sobre cualquier valor heredado de solo lectura de abajo para el mismo proveedor. Las claves guardadas aparecen como ***MASKED*** — déjalo enmascarado para conservar el valor almacenado. El OAuth de suscripción de ChatGPT se conecta en el panel de Conexiones OAuth. Guardar reemplaza toda la tabla.",
        providerLabels: {
            anthropic: "Anthropic",
            openai: "OpenAI (clave de API)",
            google: "Google",
            xai: "xAI",
            openrouter: "OpenRouter",
            custom: "Personalizado (compatible con OpenAI)",
        },
        ariaId: "id de la credencial",
        ariaProvider: "proveedor",
        ariaSecret: "secreto de la credencial",
        ariaBaseUrl: "url base",
        ariaModels: "modelos",
        idCollision: "Ya existe una credencial con este id",
        renameLocked: "Vuelve a introducir la clave/secreto antes de renombrar — un secreto almacenado no puede pasar a un nuevo id",
        secretPlaceholder: "clave / token",
        maskedHidden: "El valor almacenado permanece oculto",
        baseUrlPlaceholderOpenrouter: "https://openrouter.ai/api/v1 (predeterminado)",
        baseUrlPlaceholder: "URL base",
        modelsPlaceholder: "ids de modelo (separados por comas)",
        deleteCredential: "Eliminar credencial",
        validation: {
            missingSecret: "{id} no tiene su clave/secreto",
            secretTooLong: "el secreto de {id} es demasiado largo (máx. 8192 caracteres)",
            invalidId: '"{id}" no es un id válido (slug en kebab-case)',
            idTooLong: '"{id}" es demasiado largo (máx. {max} caracteres)',
            kindCustom: '{id}: el proveedor "{provider}" usa el tipo "custom"',
            kindApiKey: '{id}: el proveedor "{provider}" usa el tipo "api-key"',
            baseUrlRequired: '{id}: el proveedor "custom" requiere una URL base (solo OpenRouter tiene un valor predeterminado)',
            baseUrlTooLong: "{id}: la URL base es demasiado larga (máx. 400 caracteres)",
            baseUrlInvalid: "{id}: la URL base no es una URL válida",
            tooManyModels: "{id}: como máximo 16 ids de modelo",
            modelIdTooLong: '{id}: el id de modelo "{model}…" es demasiado largo (máx. 200 caracteres)',
        },
    },
    aliases: {
        addCustomAlias: "Añadir alias personalizado",
        helpBeforeDefault: "Los niveles predefinidos siempre se resuelven — revertir un predefinido a",
        helpDefaultWord: "Predeterminado",
        helpAfterDefault: "usa el catálogo de la plataforma. Los alias personalizados deben ser SHOUTY_SNAKE_CASE (p. ej. WRITER, PETITION_DRAFTER). Guardar reemplaza toda la tabla.",
        modeDefault: "Predeterminado",
        modePin: "Fijar",
        modeDelegate: "Delegar",
        modeDefaultTitle: "Resolver mediante el catálogo de la plataforma",
        modePinTitle: "Fijar una secuencia proveedor/modelo para esta organización",
        modeDelegateTitle: "Resolver lo que resuelva otro alias",
        ariaRowMode: "modo de fila",
        ariaAliasName: "nombre del alias",
        ariaDelegateTarget: "destino de la delegación",
        ariaProvider: "proveedor",
        ariaModel: "modelo",
        ariaThinking: "razonamiento",
        nameCollision: "Ya existe un alias con este nombre",
        revertTitle: "Revertir al valor predeterminado de la plataforma",
        deleteAlias: "Eliminar alias",
        delegatesTo: "delega en",
        delegateHint: "— resuelve lo que resuelva ese alias",
        resolvesViaPlatform: "se resuelve mediante el catálogo de la plataforma",
        outageDescends: "Desciende automáticamente ante una interrupción del proveedor",
        removeFallback: "Quitar reserva",
        addFallback: "Añadir reserva",
        inherit: "(heredar)",
        modelPlaceholder: "id de modelo",
        modelRequired: "El id de modelo es obligatorio",
        noCredentialTitle: "La organización no tiene credencial para este proveedor — el guardado será rechazado",
        noCredentialSuffix: " (sin credencial)",
        thinkingOverlayTitle: "Superposición de esfuerzo de razonamiento",
        rungPrimary: "1 · Principal",
        rungFallback: "2 · Reserva",
        badges: {
            platform: "plataforma",
            primary: "principal",
            fallback: "reserva",
            rescue: "rescate",
            unavailable: "no disponible",
        },
        providerLabels: {
            "openai-codex": "OpenAI Codex (ChatGPT OAuth)",
            openai: "OpenAI (clave de API)",
            anthropic: "Anthropic",
            google: "Google",
            xai: "xAI",
            openrouter: "OpenRouter",
            custom: "Personalizado",
        },
        validation: {
            primaryMissingModel: "{alias} (principal) no tiene un id de modelo",
            fallbackMissingModel: "{alias} (reserva) no tiene un id de modelo",
        },
    },
    users: {
        allStatuses: "Todos los estados",
        statusActive: "Activo",
        statusProvisioning: "Aprovisionando",
        statusDeactivated: "Desactivado",
        allRoles: "Todos los roles",
        roleOrgAdmin: "Admin de la organización",
        roleMember: "Miembro",
        addUser: "Añadir usuario",
        deactivateConfirm: "¿Desactivar a {name}?",
        revokeConfirm: "¿Revocar la invitación pendiente de {name}? El enlace deja de funcionar.",
        acceptConfirm: '¿Aceptar la invitación de {name} ({email}) en su nombre?\n\nEsto crea una identidad de Clerk con una contraseña temporal conocida y marca la invitación como aceptada. Destinado a:\n  • cuentas +clerk_test (sin entrega de correo real), o\n  • un usuario real que perdió su enlace de invitación.\n\nSi es un usuario real, DEBES indicarle que use el flujo "Olvidé mi contraseña" de Clerk de inmediato para establecer su propia contraseña.',
        failedDeactivate: "No se pudo desactivar al usuario",
        failedResend: "No se pudo reenviar la invitación",
        failedRevoke: "No se pudo revocar la invitación",
        failedAccept: "No se pudo aceptar la invitación",
        freshInvitationUrl: "Nueva URL de invitación para {email}",
        emailDeliveryFailed: "La invitación se creó, pero NO pudo entregarse a {email}. Comparte el enlace de abajo directamente.",
        emailDeliveryFailedNoUrl: "El correo se actualizó, pero la invitación no pudo entregarse a {email} y no se devolvió ningún enlace para compartir. Usa Reenviar en su fila para intentarlo de nuevo.",
        loadingUsers: "Cargando usuarios...",
        colInvitation: "Invitación",
        resendTitle: "Reenviar invitación",
        resendLabel: "Reenviar",
        revokeTitle: "Revocar invitación",
        acceptTitle: "Aceptar la invitación en nombre del usuario (desbloqueo de admin — el operador debe indicar a los usuarios reales que restablezcan su contraseña con el flujo Olvidé mi contraseña de Clerk)",
        deactivateTitle: "Desactivar usuario",
        editTitle: "Editar usuario",
        noUsersFound: "No se encontraron usuarios",
    },
    editUser: {
        title: "Editar {name}",
        failedSave: "Error al guardar los cambios",
        emailReissueHint: "Cambiar este campo revoca la invitación pendiente y envía una nueva a la nueva dirección.",
        emailLockedAccepted: "Este usuario ya ha iniciado sesión, por lo que esta dirección es ahora su credencial de acceso y solo puede cambiarse en Clerk.",
        emailLockedUnknown: "Este usuario no tiene una invitación pendiente, por lo que no es posible confirmar su estado de acceso desde aquí y la dirección se deja sin cambios.",
        emailLockedTitle: "El correo solo puede cambiarse mientras haya una invitación pendiente",
        errNotEditable: "La dirección de correo de este usuario no puede cambiarse.",
        errReissueFailed: "La dirección se guardó, pero la invitación no pudo reenviarse. Usa Reenviar en este usuario: volver a enviar este formulario no la reenviará.",
        errDuplicate: "Otro usuario de esta organización ya utiliza {email}.",
        emailNotApplied: "El servidor guardó los demás cambios, pero no aplicó el nuevo correo — está ejecutando una versión sin soporte para editar el correo. La dirección no ha cambiado.",
    },
    invite: {
        failedCreate: "No se pudo crear el usuario",
        sentTitle: "Invitación enviada",
        sentBody1: "Se está enviando un correo de invitación de Clerk a ",
        sentBody2: ". Hace clic en el enlace, establece una contraseña e inicia sesión con normalidad. ¿Necesitas el enlace directamente (p. ej. una dirección ",
        sentBody3: " que no recibirá correo real)? Usa la acción ",
        resend: "Reenviar",
        sentBody4: " en su fila una vez que termine el aprovisionamiento — devuelve una URL nueva para compartir.",
        emailPlaceholder: "Correo electrónico",
        firstNamePlaceholder: "Nombre",
        lastNamePlaceholder: "Apellido",
    },
    settings: {
        failedLoad: "No se pudo cargar la configuración",
        failedSave: "No se pudo guardar la configuración",
        loading: "Cargando configuración...",
        couldNotLoad: "No se pudo cargar la configuración",
        title: "Configuración de la organización",
        saved: "Configuración guardada",
        maxUsers: "Máx. de usuarios",
        tier: "Plan",
        tierFree: "Gratuito",
        tierStarter: "Inicial",
        tierProfessional: "Profesional",
        tierEnterprise: "Empresarial",
        saveSettings: "Guardar configuración",
    },
    audit: {
        failedLoad: "No se pudieron cargar los registros de auditoría",
        title: "Auditoría",
        filterPlaceholder: "Filtrar por acción...",
        loading: "Cargando registros de auditoría...",
        colTime: "Hora",
        colUser: "Usuario",
        colAction: "Acción",
        colEntity: "Entidad",
        colDetails: "Detalles",
        noEntries: "No se encontraron registros de auditoría",
    },
    tasks: {
        title: "Tareas",
        comingSoon: "Monitoreo de tareas por organización — próximamente",
    },
    badges: {
        status: {
            ACTIVE: "ACTIVE",
            SUSPENDED: "SUSPENDED",
            PROVISIONING: "PROVISIONING",
            DELETED: "DELETED",
            TERMINATED: "TERMINATED",
            DEACTIVATED: "DEACTIVATED",
            DEACTIVATING: "DEACTIVATING",
        },
        tier: {
            free: "free",
            starter: "starter",
            professional: "professional",
            enterprise: "enterprise",
        },
        role: {
            ORG_ADMIN: "ORG_ADMIN",
            MEMBER: "MEMBER",
        },
        storageMode: {
            shared: "compartido",
            dedicated: "dedicado",
        },
        storageModeTitle: {
            shared: "Pool compartido — los datos de la organización viven en un recurso compartido NFS Premium multi-inquilino con aislamiento por subPath aplicado por el kernel. Costo marginal de almacenamiento ~R$0/mes.",
            dedicated: "Recurso dedicado — la organización tiene su propio recurso compartido NFS Premium con ACL por recurso. Piso de costo de almacenamiento ~R$130/mes por organización.",
        },
        storageTitleFallback: "almacenamiento: {mode}",
        clientStatus: {
            active: "activo",
            prospect: "prospecto",
            inactive: "inactivo",
            former: "anterior",
        },
        matterStatus: {
            active: "activo",
            paused: "pausado",
            closed: "cerrado",
        },
        matterType: {
            civil: "civil",
            labor: "laboral",
            tax: "tributario",
            contract: "contractual",
            advisory: "consultivo",
            corporate: "societario",
            realestate: "inmobiliario",
            compliance: "compliance",
            other: "otro",
        },
        assignmentRole: {
            LEAD: "LEAD",
            HANDLER: "HANDLER",
            CONTRIBUTOR: "CONTRIBUTOR",
            OBSERVER: "OBSERVER",
        },
        invitation: {
            sent: "Enviada",
            accepted: "Aceptada",
            revoked: "Revocada",
            expired: "Expirada",
        },
    },
    clients: {
        placeholderPerson: "João da Silva",
        placeholderCompany: "Acme Brasil Ltda.",
        company: "Empresa",
        person: "Persona",
        primaryContactUserId: "ID del usuario de contacto principal",
        alias: "Identificador de referencia (@alias)",
        aliasHelp: "Se usa para referenciar a este cliente como @identificador. El servidor normaliza el formato y garantiza que sea único en la organización. Déjalo vacío para eliminarlo.",
        createClient: "Crear cliente",
        loadingClients: "Cargando clientes...",
        colMatters: "Asuntos",
        noClientsYet: "Aún no hay clientes",
        aliasTitle: "Identificador del cliente (@alias)",
        selfBadge: "propio",
        selectClient: "Selecciona un cliente...",
        selfSuffix: " (propio)",
    },
    clientDelete: {
        confirmPhrase: "LO ENTIENDO",
        title: "¿Eliminar este cliente permanentemente?",
        cleanBody: "Esta acción es DEFINITIVA y no se puede deshacer. El registro del cliente y sus asuntos vacíos serán eliminados.",
        impactTitle: "¿Eliminar cliente con casos?",
        impactBody: "Este cliente será eliminado DEFINITIVAMENTE. Los casos NO serán borrados — casos vinculados: {count} (en la papelera: {binned}). Pasarán a «Sin asignar», sin cliente ni asunto.",
        matterCases: "activos: {live} · en la papelera: {binned}",
        blockedTitle: "Este cliente aún no puede ser eliminado",
        blockedBody: "Casos en formato antiguo dependen de la carpeta de este cliente — casos bloqueando: {count}. Reasigna o migra esos casos primero.",
        blockedAck: "Entendido",
        typeToConfirm: "Escribe para confirmar:",
        deleteAction: "Eliminar cliente",
    },
    matters: {
        namePlaceholder: "Defensa en litigio de consumo",
        matterType: "Tipo de asunto",
        typeImmutable: "El tipo de asunto es inmutable tras la creación.",
        typeFixed: "El tipo de asunto es fijo para este flujo de creación.",
        primaryLeadUserId: "ID del usuario responsable principal",
        createMatter: "Crear asunto",
        loadingMatters: "Cargando asuntos...",
        colCases: "Casos",
        noMattersYet: "Aún no hay asuntos",
        selectMatter: "Selecciona un asunto...",
    },
    assignments: {
        addUserTo: {
            client: "Añadir usuario al cliente",
            matter: "Añadir usuario al asunto",
            case: "Añadir usuario al caso",
        },
        userId: "ID del usuario",
        addAssignment: "Añadir asignación",
        loading: "Cargando asignaciones...",
        scopeLabels: {
            client: "Asignaciones de cliente",
            matter: "Asignaciones de asunto",
            case: "Asignaciones de caso",
        },
        directSuffix: " — directa",
        revokeTitle: "Revocar asignación",
        noDirect: "No hay asignaciones directas.",
        inheritedTitle: "Heredadas del ámbito superior",
        colInheritedFrom: "Heredada de",
        parent: "superior",
    },
    profilePicker: {
        profileDefault: "(predeterminado del perfil)",
        unset: "(sin definir)",
        thinkingLabel: "razonamiento:",
        ariaBaseProfile: "Perfil base",
        ariaThinkingOverlay: "Superposición de razonamiento",
    },
};
//# sourceMappingURL=es-ES.js.map